import i18next, { i18n as i18nInstance, InterpolationOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import { languages, namespaces } from "./i18n.constants";
import commonDK from "./locales/dk/common.json";
import commonEN from "./locales/en/common.json";
import ariaDK from "./locales/dk/aria.json";
import ariaEN from "./locales/en/aria.json";
import clsLoggingDK from "./locales/dk/clsLogging.json";
import clsLoggingEN from "./locales/en/clsLogging.json";
import validationDK from "./locales/dk/validation.json";
import validationEN from "./locales/en/validation.json";
import termsAndConditionsDK from "./locales/dk/termsAndConditions.json";
import termsAndConditionsEN from "./locales/en/termsAndConditions.json";
import routesDK from "./locales/dk/routes.json";
import routesEN from "./locales/en/routes.json";
import gdprDK from "./locales/dk/gdpr.json";
import gdprEN from "./locales/en/gdpr.json";
import { getLocalStorageValue } from "../services/system/localStorage";
import { LocalstorageKeys } from "../enums/localstorageKeys";
import moment from "moment/min/moment-with-locales";

const createI18n = (language: string): i18nInstance => {
  moment.locale(language);
  const i18n = i18next.createInstance().use(initReactI18next);
  document.documentElement.setAttribute("lang", language);
  i18n.init({
    lng: language,
    fallbackLng: language,
    ns: [namespaces.common],
    defaultNS: namespaces.common,
    interpolation: {
      escapeValue: false, //fo date format
      format: (value: string | Date, format: string) => {
        if (format === "uppercase") return (value as string).toUpperCase();
        if (value instanceof Date) return moment(value).format(format);
        return value;
      },
    } as InterpolationOptions,
    resources: {
      [language]: {
        [namespaces.common]: commonDK,
        [namespaces.aria]: ariaDK,
        [namespaces.clsLogging]: clsLoggingDK,
        [namespaces.validation]: validationDK,
        [namespaces.termsAndConditions]: termsAndConditionsDK,
        [namespaces.routes]: routesDK,
        [namespaces.gdpr]: gdprDK,
      },
      [languages.en]: {
        [namespaces.common]: commonEN,
        [namespaces.aria]: ariaEN,
        [namespaces.clsLogging]: clsLoggingEN,
        [namespaces.validation]: validationEN,
        [namespaces.termsAndConditions]: termsAndConditionsEN,
        [namespaces.routes]: routesEN,
        [namespaces.gdpr]: gdprEN,
      },
    },
  });

  i18next.on("languageChanged", (lng) => {
    moment.locale(lng);
    document.documentElement.setAttribute("lang", lng);
  });
  return i18n;
};

export const i18n = createI18n(getLocalStorageValue(LocalstorageKeys.TranslatorLang, null) ?? languages.da);

export const mapLangCodeToLocale = (langCode: string) => {
  switch (langCode) {
    case languages.da:
      return "da-DK";
    case languages.en:
      return "en-US";
    default:
      return "da-DK";
  }
};
